/* eslint-disable import/no-anonymous-default-export */
import {
  AUTH_LOGIN,
  AUTH_LOGIN_START,
  AUTH_SIGNUP_START,
  AUTH_ERROR,
  AUTH_LOGOUT,
  AUTH_SIGNUP_ERROR,
  AUTH_SIGNUP,
  AUTH_LOGIN_2FA,
  AUTH_RISK_WARNING_ACCEPTED,
} from '../types';

const storedUser = localStorage.getItem('user_detail');

const initialState = {
  isLoggedIn: !!localStorage.getItem('token_key'),
  auth2fa: false,
  token: localStorage.getItem('token_key') || '',
  userInfo: storedUser ? JSON.parse(storedUser) : null,
  authError: false,
  authErrorMsg: '',
  success: false,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case AUTH_LOGIN_START:
      return {
        ...state,
        loading: true,
      };

    case AUTH_LOGIN_2FA:
      return {
        ...state,
        isLoggedIn: false,
        auth2fa: true,
        loading: false,
      };

    case AUTH_LOGIN:
      return {
        ...state,
        isLoggedIn: true,
        auth2fa: false,
        token: action.payload.token,
        userInfo: action.payload,
        success: true,
        loading: false,
      };

    case AUTH_SIGNUP_START:
      return {
        ...state,
        loading: true,
      };

    case AUTH_SIGNUP:
      return {
        ...state,
        isLoggedIn: !!localStorage.getItem('token_key'),
        token: action.payload.token,
        userInfo: action.payload,
        loading: false,
      };

    case AUTH_RISK_WARNING_ACCEPTED: {
      const updatedUser = {
        ...state.userInfo,
        riskWarning: true,
      };

      localStorage.setItem('user_detail', JSON.stringify(updatedUser));

      return {
        ...state,
        userInfo: updatedUser,
      };
    }

    case AUTH_ERROR:
      return {
        ...state,
        isLoggedIn: false,
        token: '',
        userInfo: null,
        authError: true,
        authErrorMsg: action.payload,
        loading: false,
      };

    case AUTH_SIGNUP_ERROR:
      return {
        ...state,
        isLoggedIn: false,
        token: '',
        userInfo: null,
        loading: false,
      };

    case AUTH_LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        auth2fa: false,
        token: '',
        userInfo: null,
      };

    default:
      return state;
  }
}
